import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M7.00651 16.3301H21.0065V13.9967H7.00651V16.3301ZM7.00651 12.8301H21.0065V10.4967H7.00651V12.8301ZM7.00651 9.33008H21.0065V6.99674H7.00651V9.33008ZM4.67318 20.9967C4.03151 20.9967 3.4822 20.7683 3.02526 20.3113C2.56832 19.8544 2.33984 19.3051 2.33984 18.6634V4.66341C2.33984 4.02174 2.56832 3.47244 3.02526 3.01549C3.4822 2.55855 4.03151 2.33008 4.67318 2.33008H23.3398C23.9815 2.33008 24.5308 2.55855 24.9878 3.01549C25.4447 3.47244 25.6732 4.02174 25.6732 4.66341V25.6634L21.0065 20.9967H4.67318Z",
        fill: "#FE6B2E"
      })
    ], -1)
  ]))]))
}
export default { render: render }